// extracted by mini-css-extract-plugin
export default {"cashback":"style_cashback__a6jZY","content":"style_content__Hd0T8","bg_main":"style_bg_main__fyCbz","bg_top":"style_bg_top__IMr9V"};